import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../../shared/shared.module';
import { MaterialModule } from '../../../../../shared/material.module';
import { AddStaffMarketingComponent } from './add-staff-marketing.component';



@NgModule({
  declarations: [
    AddStaffMarketingComponent
  ],
  exports: [
    AddStaffMarketingComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule
  ]
})
export class AddStaffMarketingModule { }
